export default "__VITE_ASSET__339751db__"